import {
	useDecisionMakerProfilePageData,
	useDMProfilePagePaginatedTargetedPetitionsData,
} from 'src/app/pages/decisionMakerProfile/pageContext';
import { useMultipleQueryParamsValue } from 'src/app/shared/hooks/location';
import { useTrackView } from 'src/app/shared/hooks/tracking';

import { useResponsivenessScoreEnabled } from '../useResponsivenessScoreEnabled';

type Result = ModelHookResult<{
	showSapContainer: boolean;
	isDmrlEnabled: boolean;
}>;

export function useLayout(): Result {
	const [sourceLocation, showDmrl] = useMultipleQueryParamsValue(['source_location', 'showDmrl']);
	const {
		data: {
			id,
			type,
			verifiedAt,
			featureConfigs: { dmReputationLayer },
		},
	} = useDecisionMakerProfilePageData();

	const {
		data: { totalCount: petitionCount },
	} = useDMProfilePagePaginatedTargetedPetitionsData();

	const responsivenessScoreEnabled = useResponsivenessScoreEnabled();

	const isDmrlEnabled = dmReputationLayer.enabled || showDmrl === 'true';

	useTrackView(
		'dm_show_view',
		{
			dm_id: `dm_${id}`,
			dm_verified: !!verifiedAt,
			dm_type: type,
			dm_petitions_num: petitionCount,
			source_location: sourceLocation,
			dm_responsiveness_score_enabled: responsivenessScoreEnabled,
		},
		[],
	);

	const shownInPetitionList = petitionCount === 1;
	const showSapContainer = !shownInPetitionList;

	return {
		data: { showSapContainer, isDmrlEnabled },
	};
}
